import { Heading, Text } from 'ui-kit/typography'
import { TbLocationFilled } from 'react-icons/tb'
import SalesForceIcon from './icon-sales-force.svg'
import clsx from 'clsx'
import classes from './IntegrationUXService.module.scss'

export const IntegrationUXService = () => {
  return (
    <section className={classes.section}>
      <div className={clsx('flex-column', classes.body)}>
        <div className={clsx('page__background', classes.background)} />
        <Heading as={'h1'} size={'xxl'} center className={classes.title}>
          Elevate Your Integration UX
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          Simplify the complexity of native integration interfaces. We provide a
          seamless solution for an exceptional user experience.
        </Text>
        <div className={classes.items}>
          <div className={clsx(classes.square, classes.square__left)} />
          <div className={clsx(classes.square, classes.square__right)} />

          <ul className={clsx('flex-column', classes.list)}>
            <li className={clsx(classes.item, classes.item__1)}>
              <Text lh={'loose'}>Initiate with</Text>
            </li>

            <li className={clsx(classes.item, classes.item__2)}>
              <TbLocationFilled
                className={clsx(classes.icon, classes.icon__salesArrow)}
              />
              <Text as={'span'} lh={'loose'} className={classes.button}>
                Connect
              </Text>
              <img
                src={SalesForceIcon.src}
                alt='Salesforce Logo'
                width={64}
                height={45}
                fetchPriority='high'
                className={clsx(classes.icon, classes.icon__salesForce)}
              />
            </li>

            <li className={clsx(classes.item, classes.item__3)}>
              <Text lh={'loose'}>One-click integration</Text>
            </li>
          </ul>
        </div>

        <Text size={'lg'} center balance className={classes.description}>
          Enhance your UI with our streamlined "Connect" button - we manage the
          entire integration process behind the scenes.
        </Text>
      </div>
    </section>
  )
}
